var swiperInstances = []; // Swiper 인스턴스를 저장할 배열

function swiperinit() {
    // 모든 슬라이드 컨테이너를 선택
    $('.benefit-modules .swiper').each(function (index, container) {
        var $container = $(container);
        var $wrapper = $container.find('.swiper-wrapper'); // .swiper-wrapper 선택
        var $parentModule = $container.closest('.benefit-modules'); // 부모 요소인 .benefit-modules 선택
        var layoutType = $parentModule.data('layout'); // data-layout 확인

        // 모바일에서는 swiper deploy 처리 css scroll 처리
        if ($(window).width() < 768) {
            if (swiperInstances[index]) {
                swiperInstances[index].destroy(true, true); // Swiper 인스턴스 제거
                swiperInstances[index] = null; // 배열에서 제거
            }
            return;
        }

        // .swiper-wrapper의 scrollWidth와 .swiper의 너비 비교
        var containerWidth = $container.outerWidth();
        var wrapperScrollWidth = $wrapper[0].scrollWidth; // .swiper-wrapper의 스크롤 너비

        if (wrapperScrollWidth > containerWidth) {
            if (!swiperInstances[index]) {
                swiperInstances[index] = new Swiper(container, {
                    loop: false, // 무한 루프 비활성화
                    slidesPerView: 'auto', // 슬라이드 너비 자동 조정
                    spaceBetween: 8, // 슬라이드 간 간격
                    scrollbar: {
                        el: $parentModule.find('.swiper-scrollbar')[0], // 부모 요소에서 스크롤바 탐색
                        draggable: true, // 드래그 가능
                    },
                    breakpoints: {
                        // PC (768px 이상)
                        768: {
                            spaceBetween: 16, // 슬라이드 간 간격
                            freeMode: true, // 스크롤 모드 활성화
                        },
                    },
                    on:{
                        slideChangeTransitionEnd: function() {
                            var swiper = this;
                            $(swiper.slides).removeAttr('inert');
                            $(swiper.slides).not(swiper.slides[swiper.activeIndex]).attr('inert', '');
                        }
                    },
                });
            }
            swiperInstances[index].update(); // Swiper 업데이트
        } else {
            // .swiper-wrapper의 scrollWidth가 .swiper의 너비보다 작거나 같을 경우 Swiper 비활성화
            if (swiperInstances[index]) {
                swiperInstances[index].destroy(true, true); // Swiper 인스턴스 제거
                swiperInstances[index] = null; // 배열에서 제거
            }
        }
    });
}

// DOM이 준비되면 초기화
$(function () {
    swiperinit();

    // window resize 이벤트 처리
    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            swiperinit(); // 화면 크기 변경 시 Swiper 재초기화
        }, 200); // 200ms 지연으로 성능 최적화
    });
});